import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import Empty from 'antd/lib/empty';
import Flex from 'antd/lib/flex';
import Modal from 'antd/lib/modal';
import React from 'react';
import { orderBy } from 'lodash';
import { ISavedFilter } from './saved-filter/interface';
import { SavedFilterCard } from './saved-filter/SavedFilterCard';

interface ISavedContentProps {
    savedFilters: ISavedFilter[];
    appliedSavedFilter: ISavedFilter | null;
    onOpenSaveFiltersModal: (filter: ISavedFilter) => void;
    onDeleteSavedFilter: (filter: ISavedFilter) => Promise<void>;
    onApplySavedFilter: (filter: ISavedFilter) => void;
}

export const SavedFiltersList: React.FC<ISavedContentProps> = ({
    savedFilters,
    appliedSavedFilter,
    onDeleteSavedFilter,
    onOpenSaveFiltersModal,
    onApplySavedFilter,
}) => {
    const [modal, contextHolder] = Modal.useModal();

    const handleFilterDelete = async (filter: ISavedFilter) => {
        modal.confirm({
            title: 'Delete Saved Filter',
            icon: <ExclamationCircleOutlined />,
            content: `Are you sure you want to delete the filter "${filter.filter_name}"? This action cannot be undone.`,
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: async () => await onDeleteSavedFilter(filter),
            onCancel: () => {},
        });
    };

    const handleFilterEdit = (filter: ISavedFilter) => {
        onOpenSaveFiltersModal(filter);
    };

    const handleFilterApply = (filter: ISavedFilter) => {
        onApplySavedFilter(filter);
    };

    if (savedFilters.length === 0) {
        return (
            <Flex justify="center" align="center">
                <Empty description="No saved filters" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Flex>
        );
    }

    const sortedFilters = orderBy(savedFilters, 'filter_name');

    return (
        <>
            {contextHolder}

            <Flex vertical>
                {sortedFilters.map(filter => (
                    <SavedFilterCard
                        key={filter.id}
                        filter={filter}
                        appliedSavedFilterId={appliedSavedFilter?.id || null}
                        onFilterApply={handleFilterApply}
                        onFilterDelete={handleFilterDelete}
                        onFilterEdit={handleFilterEdit}
                    />
                ))}
            </Flex>
        </>
    );
};
